export default __webpack_public_path__ + "static/media/Korencontactavond Kesteren 26 oktober-8.6ef8cb1e.jpg";